export default "__VITE_ASSET__py7jsfUe__"